import { render, staticRenderFns } from "./CoinStoreSellingCoinsHistory.vue?vue&type=template&id=2195b128&scoped=true&"
import script from "./CoinStoreSellingCoinsHistory.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreSellingCoinsHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreSellingCoinsHistory.vue?vue&type=style&index=0&id=2195b128&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195b128",
  null
  
)

export default component.exports